import { Typography } from '~/UIKit';
import React from 'react';
import { TFunction } from 'i18next';
import { EmailForm, EmailFormState } from './Forms/EmailForm.component';
import { PRIMARY_BLUE } from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { Error } from '~/Components';

interface RecoverPasswordComponentProps {
  t: TFunction;
  onSubmitResetEmail: (values: EmailFormState) => void;
  recoverError: IErrorResponse | null;
}

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 360,
    textAlign: 'center',
  },
  title: {
    fontWeight: 900,
    marginBottom: theme.spacing(3),
  },
  text: {
    marginBottom: theme.spacing(4),
  },
  createNewAccountText: {
    margin: '30px 0',
  },
  link: {
    textDecoration: 'none',
    color: PRIMARY_BLUE,
  },
}));

const RecoverPasswordEmailComponent = ({
  t,
  onSubmitResetEmail,
  recoverError,
}: RecoverPasswordComponentProps) => {
  const { classes } = useStyles();
  return (
    <div className={classes.container}>
      <Typography className={classes.title} data-testid="resetEmailTitle" variant="h5">
        {t('recoverPassword.email')}
      </Typography>
      <Typography className={classes.text} data-testid="resetEmailBody" variant="body2">
        {t('recoverPassword.text')}
      </Typography>
      <EmailForm onSubmitResetEmail={onSubmitResetEmail} t={t} />
      <Error error={recoverError} />
      <Typography
        align="center"
        className={classes.createNewAccountText}
        data-testid="resetEmailSignup"
        variant="body2"
      >
        <div style={{ display: 'grid', justifyContent: 'center' }}>
          <span>{t('login.createNewAccount')}</span>
          <span>{t('login.signupNow')}</span>
        </div>
      </Typography>
    </div>
  );
};

export default RecoverPasswordEmailComponent;
